export function createActivePage(page) {
    return { type: 'active', page };
}
export function createPage(page) {
    return { type: 'page', page };
}
export function createNavPrevious(page) {
    return { type: '<', page };
}
export function createNavNext(page) {
    return { type: '>', page };
}
export function createEllipsis(ellipsisPos) {
    return { type: `…${ellipsisPos}`, page: undefined };
}
export function isNav(item) {
    return item.type === '<' || item.type === '>';
}
export function isEllipsis(item) {
    return item.type === '…L' || item.type === '…R';
}
export function containsEllipsis(composition) {
    return composition.some(isEllipsis);
}
